import React from 'react';

import DataTableMui from '../../../../components/DataTableMui';

import * as S from './styles';

const emptyMessage = 'Não encontramos congêneres. Você pode fazer uma nova pesquisa.';

function Grid({ dataTable, setDataTable, selectRow, alreadySearched, loading }) {
    const rowMutation = {
        click: async (row) => {
            await selectRow(row);
        },
        hasClick: () => true,
    };

    const columnsHead = [
        {
            key: 'numeroContratoCongenere',
            selector: (row) => row.numeroContratoCongenere || '-',
            name: 'Contrato da congênere',
            sortable: true,
            direction: 'left',
            customStyles: () => ({ width: '100px' }),
        },
        {
            key: 'numeroContratoEmpresa',
            selector: (row) => row.numeroContratoEmpresa || '-',
            name: 'N contrato da empresa',
            sortable: true,
            direction: 'left',
            customStyles: () => ({ width: '100px' }),
        },
        {
            key: 'cnpjCongenere',
            selector: (row) => row.cnpjCongenere || '-',
            name: 'CNPJ da congênere',
            sortable: false,
            direction: 'left',
            customStyles: () => ({ width: '100px' }),
        },
        {
            key: 'razaoSocialCongenere',
            selector: (row) => row.razaoSocialCongenere || '-',
            name: 'Razao social da congênere',
            sortable: false,
            direction: 'left',
            customStyles: () => ({ width: '100px' }),
        },
        {
            key: 'situacaoContrato',
            selector: (row) => row.situacaoContrato || '-',
            name: 'Situação do contrato',
            sortable: false,
            direction: 'left',
            customStyles: () => ({ width: '100px' }),
        },
    ];

    return (
        <S.GridContainer>
            <DataTableMui
                clickableRow
                rowMutation={rowMutation}
                data={dataTable}
                setDataTable={setDataTable}
                emptyMessage={emptyMessage}
                columns={columnsHead}
                loading={loading}
                alreadySearched={alreadySearched}
                firstOrderBy="numeroContratoCongenere"
            />
        </S.GridContainer>
    );
}

export default Grid;
